import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CopyToClipboardButton } from "@/components/CopyToClipboardButton";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { DestructiveConfirmationAlertDialog } from "@/components/ui/destructive-confirmation-alert-dialog";
import { VideoForm } from "@/routes/video/components/VideoForm";
import { useDeleteVideoMutation, useVideo } from "@/routes/video/queries";

export const Video = ({ id }: { id: string }) => {
    const { video, loading, error } = useVideo(id);
    const navigate = useNavigate();
    const [deleteAlertOpen, setDeleteAlertOpen] = useState(false);

    const [_error, deleteVideo] = useDeleteVideoMutation();

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>Error: {error.message}</p>;
    }

    if (!video) {
        return <p>Video not found</p>;
    }

    return (
        <>
            <Card className="bg-brand-white text-brand-black m-4 rounded border-none">
                <CardHeader>
                    <CardTitle>Video</CardTitle>
                    <div className="flex items-start justify-between">
                        <div className="flex flex-col">
                            <div className="flex-row items-center">
                                <span className="text-sm">ID: {video.id}</span>
                                <CopyToClipboardButton text={video.id} />
                            </div>
                        </div>
                    </div>
                </CardHeader>
                <CardContent>
                    <div className={"flex w-1/4 flex-col gap-4"}>
                        <div className="space-y-3">
                            <VideoForm videoFragment={video} />
                        </div>
                        <span>
                            <Button
                                type="button"
                                className="bg-red-500 hover:bg-red-600"
                                onClick={() => setDeleteAlertOpen(true)}
                            >
                                Delete
                            </Button>
                        </span>
                    </div>
                </CardContent>
            </Card>

            <DestructiveConfirmationAlertDialog
                open={deleteAlertOpen}
                onOpenChange={setDeleteAlertOpen}
                onConfirm={async () => {
                    await deleteVideo({ id: video.id });
                    navigate(-1);
                }}
                title="Delete Video"
                description="Are you sure you want to delete this video? This action cannot be undone."
            />
        </>
    );
};
